/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { UserInfo } from './data-contracts'
import { HttpClient, RequestParams } from './http-client'

export class AuthenticationClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Authentication
   * @summary Логирует событие входа пользователя в систему
   * @request POST:/bff/Authentication/Login
   * @secure
   */
  authenticationLogin = (params: RequestParams = {}) =>
    this.http.request<UserInfo, any>({
      path: `/bff/Authentication/Login`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Authentication
   * @summary Логирует событие выхода пользователя из системы
   * @request POST:/bff/Authentication/Logout
   * @secure
   */
  authenticationLogout = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/bff/Authentication/Logout`,
      method: 'POST',
      secure: true,
      ...params,
    })
}
